// extracted by mini-css-extract-plugin
module.exports =  {"placeholder":"jYdB23WhOPOf6SEE4uzM","logo":"EyeX1oz_O7zPhg74nFKO"};